import * as React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { StyledSectionHeader } from '../../../../themes/styled-components';

interface IClientManifestCard {
  client?: IClient;
}

export default function ClientManifestCard (props: IClientManifestCard) {
  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ height: '100%', p: 2}}>
        <StyledSectionHeader>Manifest</StyledSectionHeader>
        {props.client && props.client.AmaPipeline?.SourceFiles?.map((item, index) => (
          <Typography key={index} component="li" color="text.secondary" sx={{fontSize: '0.7rem',}}>
            {item.Category}
          </Typography>
        ))}
      </Paper>
    </Box>
  );
}